export default __webpack_public_path__ + "static/media/Initiate's Bracers of the Burning Disc.f165bebe.jpg";